import {
  BUILTIN_ORG_ROLE_IDS,
  type BuiltinOrgRoleId,
  type OrgMemberRole,
  type OrgMemberSummary,
  type OrgRoleView,
} from '@nadoutong/contracts';
import type { I18nKey } from '../../i18n/index.ts';

export function isBuiltinOrgRoleId(value: string): value is BuiltinOrgRoleId {
  for (const id of BUILTIN_ORG_ROLE_IDS) {
    if (id === value) return true;
  }
  return false;
}

export function builtinRoleLabelKey(role: OrgMemberRole): I18nKey {
  if (role === 'owner') return 'organization.role.owner';
  if (role === 'admin') return 'organization.role.admin';
  if (role === 'finance') return 'organization.role.finance';
  return 'organization.role.member';
}

/**
 * Select value for a member row. `customRoleId` is on the vendored
 * `OrgMemberSummary` as of router #2312; keep the field optional so a
 * payload from an environment that has not yet deployed that batch
 * still renders the builtin name.
 */
export function memberAssignedRoleId(
  member: Pick<OrgMemberSummary, 'role'> & { readonly customRoleId?: string | null },
): string {
  const custom = member.customRoleId;
  return typeof custom === 'string' && custom.length > 0 ? custom : member.role;
}

export function roleHasMembersManage(role: OrgRoleView): boolean {
  return role.permissions.includes('org:members:manage');
}

export function customOrgRoles(roles: readonly OrgRoleView[]): readonly OrgRoleView[] {
  return roles.filter((role) => !role.builtin);
}

export function assignableOrgRoles(roles: readonly OrgRoleView[]): readonly OrgRoleView[] {
  return roles.filter((role) => role.id !== 'owner');
}
